export default function voyageArrivalWindowDataToJson(arrivalWindow) {
    return {
        "earliest_eta": arrivalWindow.earliestEta,
        "latest_eta": arrivalWindow.latestEta,
        "enforce": arrivalWindow.enforce
    }
}